// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Wh9n","errorLogs":"EditorFooter_errorLogs__BJRfH"};